import { Space } from 'antd';
import styled from 'styled-components';

export const StyledInfoContainer = styled(Space)`
  padding: 24px;
  width: 100%;
  background-color: #f9fafc;
  border-radius: 8px;
  margin-bottom: 16px;
  margin-top: 8px;
`;
